import React, { Component } from "react";
import ArticleComments from "./ArticleComments"
import { Link } from 'react-router-dom';
import * as routes from '../Constants/routes';

class Friday2 extends Component {


  render() {
    var spacerStyle = {
      marginTop: "100px",

    }
    var cardGalleryStyle = {
      padding:20,
      backgroundColor: "white"
    }

    var imgCenterStyle = {
    display: "block",
    margin:"0 auto",
    marginBottom: 15
    }

    var size13 = {
      fontSize: 13
    }

    var answerStyle = {
      fontSize:16
    }

    return (

      <div className="container Site-content" id="cardGalleryWrapper" style={spacerStyle}>
        <div id="cardGallery" style={cardGalleryStyle} className="rounded">

          <h1>Friday Night Blitz 2: Tournament Recap</h1>

          <p style={size13}>
            By: Psynight - April 7, 2018
          </p>

          <img src={"../ArticleImages/Caelia310x180.jpg"} style={imgCenterStyle} className="img-fluid" id="caelia" alt="caelia" />
          <p style={answerStyle}>
          We had our second tournament Friday night with 8 players participating, doubled the size of our tournament in only a week.
          Everyone had fun and were excited to try building more competitive decks for future tournaments.  During the tournament Cannabourne made the comment
          "This feels like the early days of Magic, no netdecking and all experimentation."  And while I hope my sight addresses the lack of netdecking options, I totally agree
          with the sentiment.  I am fairly certain that every deck this week was different than last weeks decks.
          </p>
          <p style={answerStyle}>
          The players were Uni, Psynight (myself), Siba, GoldenDragon, Niboshi, Krighton, AgentCrypto, and Cannabourne.
          </p>

          <ul>
            <li>Uni brought <Link to={routes.DECKVIEW + "72swTZq0QSHztjWL1UdM"}>"summon"</Link></li>
            <li>Psynight brought <Link to={routes.DECKVIEW + "VLj7z0geV88cHvL7B3tl"}>"Zombie Demons"</Link></li>
            <li>Siba brought <Link to={routes.DECKVIEW + "0X8WpjyyTyRwbhU1fowK"}>"Kaiju"</Link></li>
            <li>Niboshi brought <Link to={routes.DECKVIEW + "FCBasKiuVKwoCHjBdURL"}>"Chaso Arcane Agro"</Link></li>
            <li>Cannabourne brought <Link to={routes.DECKVIEW + "ngviBccQ8YFZkf2xfKO8"}>"First Strike"</Link></li>
            <li>AgentCrypto brought <Link to={routes.DECKVIEW + "ZOCE5x7QJRX1zETCxBoy"}>"Djinn Miracle"</Link></li>
          </ul>

          <h5> Highlights </h5>
          <p>
            {"Two of the decks are missing because there was some confusion as to where to checkin at, the answer is checkin on this site not Challonge.  But it is all good."}
          </p>
          <p>
          {"I did not do well enough that a round by round recap would be worth telling, I brought one of my favorite decks but it was not really up to par."}
          </p>
          <p style={answerStyle}>
          {"Instead I will share some of the highlights and my thoughts on the decks that were brought."}
          </p>
          <p style={answerStyle}>
          {"Unfortunately I did not get to play against Uni, I did check out his deck though and it looks really cool, I have a Caelia deck revolving around buffs and Tech, but the curse package would be way stronger I will definitely be seeing what I can pull together."}
          </p>
          <p style={answerStyle}>
          {"My first round was against Siba he brought a very strong Kaiju Egg deck.  The first game was really bizarre he did not find an egg until around 11+ energy.  But almost the rest of his deck was control so he just killed every creature I put down.  When an egg and Kaiju finally did show up I was able to steal control and kill him with the Kaiju."}
          </p>
          <p style={answerStyle}>
          {"Niboshi had an interesting take on the Chaos Aggro archtype.  The arcane that he had mixed in revolved around stealing my units, that on top of the constant aggro push was very effective.  And as always Suprise Attack just wins games."}
          </p>
          <p style={answerStyle}>
          {"After the tournament was done AgentCrypto asked if I wanted to play a tiebreaker for 4th place, I didn't get to play him during the tournament so I agreed.  His deck was really cool, a very long game (long for Nova Blitz anyways) that ended in multiple uses of Madness leaving me with nothing in my hand.  It is a really cool control deck, I think it is the first time I had seen Madness played."}
          </p>
          <h5>Results and Final Thoughts</h5>
          <p style={answerStyle}>
          {"This tournament was really close Uni, Niboshi and Siba were all tied in match score but Uni had the tiebreaker.  Like last week I'm already looking forward to next week.  Many that played in this tournament said they will be back and were pumped to go theorycraft some decks.  Thanks to all that came and spread the word. The more the merrier."}
          </p>
        </div>
          <ArticleComments articleId={"8"} />
      </div>


    );
  }
}

export default Friday2;



// WEBPACK FOOTER //
// ./src/Articles/Friday2.js